/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Showcase_Value_ExcellentInputs */



/**
* | output |
* | --- |
* | "Excellent" |
*
* @param {Model_Showcase_Value_ExcellentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_showcase_value_excellent = /** @type {((inputs?: Model_Showcase_Value_ExcellentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Showcase_Value_ExcellentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sehr gut")
	return /** @type {LocalizedString} */ ("Excellent")
});